module.exports = __webpack_public_path__ + "img/icon_my.da0e31e.webp";